import { CompanyCell } from "./CompanyCell/CompanyCell";
import { InvestorsCell } from "./InvestorsCell/InvestorsCell";
import { FinancialStageCell } from "./FinancialStageCell/FinancialStageCell";
import { ValuationCell } from "./ValuationCell/ValuationCell";
import { TotalFundingCell } from "./TotalFundingCell/TotalFundingCell";
import { LocationCell } from "./LocationCell/LocationCell";
import { WebsiteCell } from "./WebsiteCell/WebsiteCell";
import styles from "./RowCell.module.scss";
import { TCompany } from "@/frontend/pages/DashboardPage/const/const";
import { headers } from "../TableLabels/const/const";
import { FoundingDateCell } from "./FoundingDateCell/FoundingDateCell";

type TRowCellProps = {
  colId: string;
  data: TCompany;
  isFounder?: boolean;
};

type TCompanyIndexable = TCompany & { [key: string]: any };

export function RowCell({ colId, data, isFounder }: TRowCellProps) {
  const field = (data as TCompanyIndexable)[colId];

  switch (colId) {
    case "name":
      return <CompanyCell field={data} isFounder={isFounder} />;
    case "financialStage":
      return <FinancialStageCell field={field} />;
    case "valuation":
      return <ValuationCell field={field} />;
    case "totalFunding":
      return <TotalFundingCell field={field} />;
    case "investors":
      return <InvestorsCell field={data.harmonicInvestors || []} />;
    case "city":
      return <LocationCell field={data} />;
    case "website":
      return <WebsiteCell field={field} />;
    case "foundingDate":
      return <FoundingDateCell field={field} />;
    default:
      return null;
  }
}

export function buildCells(portfolioCompany: TCompany, isFounder?: boolean) {
  return headers.map((header) => (
    <div key={header.key} className={styles.cell}>
      <RowCell data={portfolioCompany} colId={header.key} isFounder={isFounder} />
    </div>
  ));
}
